import { EditPasswordReset } from '@/features/password-reset/routes/EditPasswordReset';
import { CreatePasswordRest } from '@/features/password-reset/routes/CreatePasswordRest';
import { ExpiredPasswordReset } from '@/features/password-reset/routes/ExpiredPasswordReset';
import { Route, Routes } from 'react-router-dom';

export const PasswordResetRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<CreatePasswordRest />} />
      <Route path="/edit" element={<EditPasswordReset />} />
      <Route path="/expired" element={<ExpiredPasswordReset />} />
    </Routes>
  );
};
